import { motion } from "framer-motion";
import { Building2, Landmark, Shield, Sprout, Stethoscope, Factory } from "lucide-react";

const customers = [
  { icon: Landmark, label: "NBFCs & Banks", desc: "Voice AI for collections, servicing, and KYC" },
  { icon: Shield, label: "Insurance Companies", desc: "Claims processing and customer engagement" },
  { icon: Building2, label: "Government Agencies", desc: "Citizen services and digital governance" },
  { icon: Sprout, label: "Agri-Enterprises", desc: "Smart farming and aquaculture solutions" },
  { icon: Stethoscope, label: "Healthcare Providers", desc: "Clinical AI and telemedicine support" },
  { icon: Factory, label: "Defense & PSUs", desc: "Sovereign AI for critical infrastructure" },
];

export const PartnersSection = () => (
  <section id="partners" data-testid="partners-section" className="py-24 md:py-32 section-alt relative">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <p className="text-[#c9a84c] font-heading font-semibold text-sm tracking-widest uppercase mb-4">
          Who We Serve
        </p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-foreground tracking-tight">
          Target <span className="text-gradient-gold">Industries</span>
        </h2>
      </motion.div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {customers.map((c, i) => (
          <motion.div
            key={c.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="glass-card rounded-lg p-8 text-center group"
            data-testid={`partner-${i}`}
          >
            <div className="w-16 h-16 rounded-full bg-[#c9a84c]/10 flex items-center justify-center mx-auto mb-5 group-hover:bg-[#c9a84c]/20 transition-colors duration-300">
              <c.icon className="h-7 w-7 text-[#c9a84c]" />
            </div>
            <h3 className="font-heading font-semibold text-foreground text-lg">{c.label}</h3>
            <p className="font-body text-muted-foreground text-sm mt-2">{c.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
